"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLogger = void 0;

var tslib_1 = require("tslib");

var package_details_1 = require("@hopin-team/package-details");

var Sentry = tslib_1.__importStar(require("@sentry/node"));

var initializeSentry_1 = require("./initializeSentry");

var getLogger = function getLogger(_a) {
  var _b, _c, _d;

  var consumerId = _a.consumerId,
      sentryDsn = _a.sentryDsn,
      sentryEnv = _a.sentryEnv,
      sentryRelease = _a.sentryRelease,
      _e = _a.customOptions,
      customOptions = _e === void 0 ? {} : _e,
      _f = _a.withSentry,
      withSentry = _f === void 0 ? true : _f;
  var isSentryInitialized = ((_d = (_c = (_b = Sentry === null || Sentry === void 0 ? void 0 : Sentry.getCurrentHub()) === null || _b === void 0 ? void 0 : _b.getClient()) === null || _c === void 0 ? void 0 : _c.getDsn()) === null || _d === void 0 ? void 0 : _d.toString()) === sentryDsn;

  if (sentryDsn && !isSentryInitialized) {
    (0, initializeSentry_1.initializeSentry)({
      sentryDsn: sentryDsn,
      sentryEnv: sentryEnv,
      sentryRelease: sentryRelease,
      customOptions: customOptions
    });
  }

  var _g = (0, package_details_1.packageDetails)(consumerId),
      packageScope = _g.scope,
      packageName = _g.name,
      packageVersion = _g.version;

  return {
    error: function error(err) {
      if (err === void 0) {
        err = {};
      }

      return console.error(err);
    },
    warn: function warn(message) {
      if (message === void 0) {
        message = '';
      }

      return console.warn(message);
    },
    info: function info(message) {
      if (message === void 0) {
        message = '';
      }

      return console.info(message);
    },
    debug: function debug(d) {
      if (d === void 0) {
        d = '';
      }

      return console.debug(d);
    },
    captureException: function captureException(_a) {
      var _b = _a === void 0 ? {
        error: {}
      } : _a,
          error = _b.error,
          customTags = _b.customTags,
          customFingerprint = _b.customFingerprint;

      console.error(tslib_1.__assign({
        error: error,
        customTags: customTags
      }, !!(customFingerprint === null || customFingerprint === void 0 ? void 0 : customFingerprint.length) && {
        customFingerprint: customFingerprint
      }));
      withSentry && Sentry.withScope(function (scope) {
        scope.setLevel('error');
        scope.setTags(tslib_1.__assign({
          caughtBy: 'logging-provider',
          packageScope: packageScope,
          packageName: packageName,
          packageVersion: packageVersion
        }, customTags));
        !!(customFingerprint === null || customFingerprint === void 0 ? void 0 : customFingerprint.length) && scope.setFingerprint(customFingerprint);
        Sentry.captureException(error);
      });
    }
  };
};

exports.getLogger = getLogger;